// extracted by mini-css-extract-plugin
export default {"wrapper":"header_wrapper__didg0","title":"header_title__gA+hp","icons":"header_icons__GJUYW","menuButtonHidden":"header_menuButtonHidden__-mg0W"};